import { makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import MessagesContext from '../../contexts/messagesContext';
import useCheckMobileScreen from '../../hooks/useWidth';
import PatientFileHeader from './index';
import { PropTypes } from 'prop-types';
import { useMeasure } from '../../hooks/useMeasure';
const styles = makeStyles((theme) => ({
    container: ({ unsetBackground, backgroundColor, isForm }) => ({
        background: '#fff',
        height: '100%',
        [theme.breakpoints.down(1025)]: {
            padding: unsetBackground ? '0' : '24px',
            backgroundColor: backgroundColor ? backgroundColor : '#f2f4fa',
            height: ({ height }) =>
                (isForm && height >= 145) || (!isForm && height >= 102)
                    ? `calc(100vh - ${height + 'px'})`
                    : !isForm && height < 102
                    ? 'calc(100vh - 110px)'
                    : 'calc(100vh - 175px)',
            overflow: 'auto'
        }
    })
}));
function WithPatientFileHeader(WrappedComponent, titles, unsetBackground, backgroundColor, isForm) {
    return function PageContainer(props) {
        const { messages } = useContext(MessagesContext);
        const isMobile = useCheckMobileScreen();
        const [ref, { height }] = useMeasure();
        const classes = styles({
            unsetBackground: Boolean(unsetBackground && isMobile),
            backgroundColor,
            isForm,
            height: Math.round(height)
        });
        let title;
        for (const prop of titles) {
            if (title) {
                title = title[prop];
            } else {
                title = messages[prop];
            }
        }
        PageContainer.propTypes = {
            location: PropTypes.object
        };

        return (
            <>
                {isMobile && (
                    <div ref={ref}>
                        <PatientFileHeader title={title} isForm={isForm} />
                    </div>
                )}
                <div className={classes.container}>
                    <WrappedComponent {...props} />
                </div>
            </>
        );
    };
}

export default WithPatientFileHeader;
